import { format, parseISO } from 'date-fns'

export const getTicketProtocol = ticket => {
  if (!ticket) return ''

  if (ticket.protocol) {
    return ticket.protocol
  }

  if (!ticket.id) return ''

  const baseDate = ticket.createdAt ? new Date(ticket.createdAt) : new Date()

  if (Number.isNaN(baseDate.getTime())) {
    return String(ticket.id)
  }

  const day = String(baseDate.getDate()).padStart(2, '0')
  const month = String(baseDate.getMonth() + 1).padStart(2, '0')
  const year = baseDate.getFullYear()

  return `${day}${month}${year}-${ticket.id}`
}

export const formatAudioDownloadName = (ticket, message) => {
  const protocol = getTicketProtocol(ticket)
  const dateStr = message?.createdAt
    ? format(parseISO(message.createdAt), 'dd-MM-yyyy')
    : format(new Date(), 'dd-MM-yyyy')
  const timeStr = message?.createdAt
    ? format(parseISO(message.createdAt), 'HH-mm')
    : format(new Date(), 'HH-mm')
  return `${protocol}_${dateStr}_${timeStr}.mp3`.replace(/[\\/:*?"<>|]/g, '_')
}
